/* eslint-disable @typescript-eslint/naming-convention */
export class ColumnDataTypes {
	public static CHAR = 'CHAR';
	public static NUMERIC = 'NUMERIC';
	public static DATE = 'DATE';
	public static DATETIME = 'DATETIME';
	public static TIME12 = 'TIME12';
	public static TIME24 = 'TIME24';
	public static IMAGE = 'IMAGE';
}
